export const HELP_ROUTE = '/help';
export const HELP_SEARCH_ROUTE = `${HELP_ROUTE}/search`;
export const HELP_COLLECTION_SLUG = 'agentnet';
export const HELP_SITE_SETTINGS_ID = '7Cb1Fdl72TOOso0C1lBmMf';
